import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Toast } from '../../../components/Toast';
import { verifOrder } from '../../../actions/cartActions';
import ScanditInit from '../../../components/Scandit/Sandit';
import { useOrderLogger } from '../../../hooks/useOrderLogger';

export const useScanVerification = (cartItems, user, axiosInstance) => {
  const [Code, setCode] = useState();
  const [isDestroy, setIsDestroy] = useState(false);
  const [isScanditLoaded, setIsScanditLoaded] = useState(false);
  const dispatch = useDispatch();
  const { logInvalidCheckoutQR } = useOrderLogger();

  useEffect(() => {
    const initScandit = async () => {
      try {
        await ScanditInit();
        setIsScanditLoaded(true);
      } catch (err) {
        console.error('Error in ScanditInit:: ', err);
      }
    };

    initScandit();
  }, []);

  useEffect(() => {
    if (Code) {
      const param = /verif=([^&]+)/;
      const deviceNameParam = /deviceName=([^&]+)/;
      
      const match = Code.match(param);
      const deviceNameMatch = Code.match(deviceNameParam);
      const verif = match ? match[1] : null;
      const deviceName = deviceNameMatch ? decodeURIComponent(deviceNameMatch[1]): null;

      if (verif === cartItems?.storeId) {
        setIsDestroy(true);
        dispatch(verifOrder(cartItems?._id, user, axiosInstance, deviceName));
      } else {
        Toast('error', 'Mauvais Qr code');
        try {
          logInvalidCheckoutQR(
            cartItems?._id,
            user?._id || user?.id || null,
            Code,
            cartItems?.storeId,
          );
        } catch (e) {
          console.error('Error in logInvalidCheckoutQR:: ', e);
        }
        setCode(0);
      }
    }
  }, [Code]);

  return { Code, setCode, isDestroy, setIsDestroy, isScanditLoaded };
};